export const selectSelectedLanguage = ({ language }) => language.selected;
